import './HomepageSocialPreview.css'
import { StoreButtons } from './Website'
import { EvoLogoFullSvg } from './share/components/icons'
import { HomepageTiltSlab } from './HomepageTiltSlab'

export default function HomepageSocialPreview() {
  return (
    <main className="homepage-social-preview" data-homepage-social-preview>
      <section className="homepage-social-copy">
        <span className="homepage-social-logo">
          <EvoLogoFullSvg height={42} />
        </span>
        <h1>Predict your next PSA submission</h1>
        <p>AI grading, centering, damage checks, and collection tracking for TCG cards.</p>
        <StoreButtons variant="darkBadge" />
      </section>

      <section className="homepage-social-slab-wrap" aria-label="Evo grading preview">
        <HomepageTiltSlab className="homepage-social-slab" />
      </section>
    </main>
  )
}
